<template>
  <div class="about-page">
    <!-- 影片內容區 -->
    <section class="video-section">
      <div class="container">
        <h2 class="section-title text-center" data-aos="fade-up">
          產品影片展示
        </h2>

        <!-- 隱藏篩選按鈕 -->
        <div id="videoGrid" class="video-grid" data-aos="fade-up">
          <div
            v-for="video in paginatedVideos"
            :key="video.id"
            class="video-card"
            @click="openVideoDetail(video)"
          >
            <div class="video-container">
              <iframe
                :src="getYoutubeEmbedUrl(video.youtubeId)"
                :title="video.title"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="video-info">
              <h3 class="video-title">{{ video.title }}</h3>
              <p class="video-description">{{ video.description || "" }}</p>
            </div>
          </div>
        </div>

        <div v-if="isLoading" class="loader">
          <i class="fas fa-spinner"></i>
        </div>

        <div v-if="filteredVideos.length === 0" class="no-content">
          <i class="fas fa-video-slash"></i>
          <p>暫無相關影片</p>
        </div>

        <!-- 分頁控制 (新增部分) -->
        <div class="pagination-container" v-if="filteredVideos.length > 0">
          <div class="pagination">
            <button
              class="page-btn prev"
              @click="prevPage"
              :disabled="currentPage === 1"
              :class="{ disabled: currentPage === 1 }"
            >
              <i class="fas fa-chevron-left"></i>
            </button>

            <div class="page-numbers">
              <button
                v-for="page in displayedPages"
                :key="page"
                @click="changePage(page)"
                class="page-number"
                :class="{ active: currentPage === page }"
              >
                {{ page }}
              </button>
            </div>

            <button
              class="page-btn next"
              @click="nextPage"
              :disabled="currentPage === totalPages"
              :class="{ disabled: currentPage === totalPages }"
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <!-- <div class="page-info">
            顯示 {{ paginatedVideos.length }} 件影片，共
            {{ filteredVideos.length }} 件
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script src="@/assets/js/video.js"  defer></script>
<style scoped src="@/assets/css/video.css"></style>
